import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

/**
 * @description
 * @author Abhishek
 * @date 08/04/2021
 * @param checked:Boolean
 * @param onChange: g()
 */
const CustomCheckbox = ({checked, onChange, label, className, formControlClass}) => {
    return (
        <React.Fragment>
        <FormControlLabel
            className={formControlClass || ''}
            control={
            <Checkbox
                checked={checked}
                onChange={onChange}
                name="checked"
                className={className || ''}
            />
            }
            label={label || ""}
        />
        </React.Fragment>
    );
}

export default CustomCheckbox